<mdb-navbar SideClass="navbar navbar-dark navbar-expand-lg custom-navbar" [containerInside]="false">
  <mdb-navbar-brand class="text-white py-2">
    <chapps-apps-list [hidden]="showBackButton()" [applicationName]="Localization.ApplicationName"></chapps-apps-list>
    <h5 *ngIf="showBackButton()" class="ml-2 mb-0 d-flex align-items-center" appTextColor="secondary" (click)="goBack()">
      <i class="fa fa-lg fa-angle-left mr-2"></i>
      <span>{{Localization.Back | translate}}</span>
    </h5>
  </mdb-navbar-brand>
  <links>
    <ul class="navbar-nav ml-auto">
      <li class="nav-item rounded" [appBg]="(isDashboardButtonActive) ? 'secondary' : 'none'" brightness="normal">
        <a routerLink="/dashboard" class="nav-link waves-light" mdbWavesEffect>
          <i class="fa fa-home mr-1"></i>
          <span>{{Localization.Dashboard | translate}}</span>
        </a>
      </li>
      <li class="nav-item rounded" [appBg]="(isNotificationsButtonActive) ? 'secondary' : 'none'" brightness="normal">
        <a routerLink="/notifications" class="nav-link waves-light" mdbWavesEffect>
          <i class="fa fa-bell mr-1"></i>
          <span>{{Localization.Notifications | translate}}</span>
        </a>
      </li>
      <li class="nav-item rounded" [appBg]="(isResidentsButtonActive) ? 'secondary' : 'none'" brightness="normal">
        <a routerLink="/residents" class="nav-link waves-light" mdbWavesEffect>
          <i class="fa fa-users mr-1"></i>
          <span>{{Localization.Residents | translate}}</span>
        </a>
      </li>
      <li class="nav-item rounded" [appBg]="(isAnnouncementsButtonActive) ? 'seqcondary' : 'none'" brightness="normal">
        <a routerLink="/announcements" class="nav-link waves-light" mdbWavesEffect>
          <i class="fa fa-bullhorn  mr-1"></i>
          <span>{{Localization.Announcements | translate}}</span>
        </a>
      </li>
      <li class="nav-item rounded" [appBg]="(isDocumentsButtonActive) ? 'secondary' : 'none'" brightness="normal">
        <a routerLink="/documents" class="nav-link waves-light" mdbWavesEffect>
          <i class="fa fa-file mr-1"></i>
          <span>{{Localization.Documents | translate}}</span>
        </a>
      </li>
      <li class="nav-item dropdown rounded" dropdown #dropdown1="bs-dropdown" [appBg]="(areSettingsActive) ? 'secondary' : 'none'">
        <a dropdownToggle mdbRippleRadius type="button" class="nav-link dropdown-toggle waves-light pl-3 pr-3"
          mdbRippleRadius (click)="userDropdown.hide()">
          <i class="fa fa-cog mr-1"></i>
          <span class="d-xl-none">{{ Localization.Settings | translate }}</span>
          <span class="caret"></span>
        </a>
        <div *dropdownMenu class="dropdown-menu dropdown dropdown-ins dropdown-menu-right" role="menu">
          <a routerLink="/businessstyle"
             class="dropdown-item waves-light" mdbWavesEffect>
            <i class="fa fa-palette mr-1"></i>
            <span>{{Localization.BusinessStyle | translate}}</span>
          </a>
          <a routerLink="/email/settings" class="dropdown-item waves-light"
             *ngIf="features.isEnabled('spf')"
            mdbRippleRadius (click)="dropdown1.hide()">
            <i class="fa fa-envelope mr-1"></i>
            <span>{{ Localization.Email | translate }}</span>
          </a>
          <a routerLink="/logins" class="dropdown-item waves-light" [class.active]="isLoginsButtonActive"
            mdbRippleRadius (click)="dropdown1.hide()">
            <i class="fa fa-address-book mr-1"></i>
            <span>{{ Localization.Logins | translate }}</span>
          </a>
        </div>
      </li>
      <li class="nav-item dropdown" dropdown #userDropdown="bs-dropdown">
        <a dropdownToggle type="button" class="nav-link dropdown-toggle waves-light" mdbWavesEffect>
          <i class="fa fa-user mr-1"></i>
          <span class="caret"></span>
        </a>
        <div *dropdownMenu class="dropdown-menu dropdown dropdown-ins dropdown-menu-right" role="menu">
          <app-chapps-card [logoUrl]="config.CHAPPS_ACCOUNT_LOGO_URL" [userName]="userName"
                           [userEmail]="userEmail" (accountClicked)="goToAccount()"
                           (signOutClicked)="logout()">
          </app-chapps-card>
        </div>
      </li>
    </ul>
  </links>
</mdb-navbar>

